// extracted by mini-css-extract-plugin
export var box = "_1s-1";
export var checkboxRow = "_1s-8";
export var checked = "_1s-2";
export var descriptionSpacer = "_1s-a";
export var disabled = "_1s-3";
export var icon = "_1s-6";
export var input = "_1s-0";
export var labelSpacer = "_1s-9";
export var medium = "_1s-5";
export var small = "_1s-4";
export var text = "_1s-7";